import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
} from "@angular/core";
import { MatCard, MatCardContent } from "@angular/material/card";
import {
  ButtonClass,
  ButtonComponent,
  ClaasIconElementsComponentService,
  Icon,
  IconButtonComponent,
  IconButtonIconSize,
  IconComponent,
} from "@claas/claas-ui-components";
import { ApplicationView } from "../../data/applications.model";

const FAVORITE_ICON_IDS = {
  filled: "649134",
  outline: "1171116",
};

@Component({
  selector: "app-application-card",
  templateUrl: "./application-card.html",
  styleUrls: ["./application-card.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatCard,
    MatCardContent,
    ButtonComponent,
    IconButtonComponent,
    IconComponent,
  ],
})
export class ApplicationCardComponent {
  readonly app = input.required<ApplicationView>();
  readonly isFavorite = input.required<boolean>();
  readonly favoriteToggled = output<string>();

  protected readonly buttonClass = ButtonClass;
  protected readonly iconButtonSize = IconButtonIconSize;
  protected readonly favoriteIcon = computed<Icon>(() => ({
    namespace: "cc",
    iconId: this.isFavorite()
      ? FAVORITE_ICON_IDS.filled
      : FAVORITE_ICON_IDS.outline,
    iconStyle: this.isFavorite() ? "bold" : "linear",
  }));

  constructor() {
    const iconService = inject(ClaasIconElementsComponentService);
    for (const iconId of Object.values(FAVORITE_ICON_IDS)) {
      iconService.registerIconById("cc", iconId).subscribe();
    }
  }

  protected toggleFavorite(): void {
    this.favoriteToggled.emit(this.app().id);
  }

  protected openApp(): void {
    const link = this.app().link;
    if (link) {
      window.open(link, "_blank", "noopener,noreferrer");
    }
  }
}
